module.exports = __webpack_public_path__ + "static/img/solutionPic2.a28d1d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionPic2.png
// module id = 4Pcm
// module chunks = 1